import { React, useState } from "react";
import "./Grid.css";
import DailyActivity from "./DailyActivity";
import ReadingsChart from "./ReadingsChart";
import BreathalyzerReadings from "./BreathalyzerReadings";

const ReadingsModal = (props) => {
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  return (
    <div className="breathalyzerModal">
      <div style={{ display: "flex", flexDirection: "column" }}>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <p style={{ fontSize: "40px" }}>Breathalyzer Readings</p>
          <div className="color-key">
            <span style={{ fontWeight: "lighter" }}>Less</span>
            <div>
              <div
                className="key-scale"
                style={{ backgroundColor: "#ebedf0" }}
              ></div>
              <div
                className="key-scale"
                style={{ backgroundColor: "#9be9a8" }}
              ></div>
              <div
                className="key-scale"
                style={{ backgroundColor: "#40c463" }}
              ></div>
              <div
                className="key-scale"
                style={{ backgroundColor: "#30a14e" }}
              ></div>
              <div
                className="key-scale"
                style={{ backgroundColor: "#216e39" }}
              ></div>
            </div>
            <span style={{ fontWeight: "lighter" }}>More</span>
          </div>
        </div>
        <hr
          style={{
            width: "100%",
            height: "2px",
            backgroundColor: "#BBBBBB",
            border: "none",
            marginTop: "8px",
          }}
        />
      </div>

      <div className="lg:flex justify-between items-center">
        <div className="lg:w-[50%]">
          <BreathalyzerReadings
            currentMonth={currentMonth}
            setCurrentMonth={setCurrentMonth}
            targetValue={props?.patientInfo?.readingsPerDay}
            user={props.user}
          />
        </div>
        <div className="lg:w-[50%]">
          <ReadingsChart
            user={props.user}
            patientInfo={props.patientInfo}
            breathalyzer={props.breathalyzer}
            currentMonth={currentMonth}
          />
        </div>
      </div>

      <DailyActivity user={props.user} />
    </div>
  );
};

export default ReadingsModal;
